import { render, staticRenderFns } from "./TruckParkingsSecuredLayer.vue?vue&type=template&id=52b088fa"
import script from "./TruckParkingsSecuredLayer.vue?vue&type=script&lang=js"
export * from "./TruckParkingsSecuredLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports